// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectConfig_select__27Dcv"};